import { SearchFilter } from '../common/search-filter';
import { Document } from '../document/document';

export interface AggregateDocumentConfirmingFinancialRequest {
	Document: Document;
	FinancialRequestSequenceNumber: string;
	FinancialRequestSubmissionDate: string;
	FinancialRequestState: string;
	FinancialRequestType: string;
}

export class FinancialMovementSearchCriteria extends SearchFilter {
	DocumentId: string;
}

export class FinancialMovementResult {
	EffectivePaymentValue: number;
	DocumentMovementAccumulatedAmount: number;
	PaymentRegistrationDate: string;
	MovementValueDate: string;
	FinancierPaymentNumber: string;
	FinancierPaymentMethod: string;
	BuyerIban: string;
	BankMovementReference: string;
	FinancierProcessingMode: string;
	checkedLifecycle: boolean;
}

export class ReportingFinancialMovementsCriteria {
	contractId: string;
	movementValueDateStart: string;
	movementValueDateEnd: string;
}
